import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    canDisplayAppNotifications(): boolean {
      return getState().queue.length > 0;
    },
    getAppNotifications() {
      return getState().queue.filter(
        ({ flags, args }) =>
          flags.length > 0 || (args.message || "").length > 0,
      );
    },
  };
}

export { createSelector };
